<template>
  <div class='vip-card-wrap'>
    <!-- 会员卡片 -->
    <show-card 
      :level='viplevel' 
      :current-index='currentIndex'
      :privleft='privLeft'
      :level-class='levelName[0]'></show-card>
    <!-- 会员权益 -->
    <rights-list 
      :current-index='currentIndex' 
      :list='showRightsList' 
      :level-name='levelName[1]'
      @change-modal-status='changeModalStatus'></rights-list>
    <!-- 买礼包送会员 -->
    <gift-bag-list 
      v-if="bagInfo && bagInfo.itemList && bagInfo.itemList.length"
      :level='viplevel'
      :current-index='currentIndex'
      :bag-info='bagInfo'
      @change-modal-status='changeModalStatus'
    ></gift-bag-list>
    <!-- 升级条件 -->
    <upgrading-conditions 
      :current-index='currentIndex'
      :level-name='levelName[1]'
      :list='showConditionList'
      ></upgrading-conditions>
    <!-- 其他入口 -->
    <entrance-list :list='bottomList'></entrance-list>
    <!-- 购买按钮 -->
    <buy-btn 
      :info="buyBtnInfo"
      :bagNum='bagInfo && bagInfo.itemList && bagInfo.itemList.length'
      @change-modal-status='changeModalStatus'
      v-if="buyBtnInfo"
    ></buy-btn>
    <!-- 购买会员弹窗 -->
    <buy-vip-modal 
      :current-index='modalLevel'
      :vip-info='showModalInfo'
      :is-show='isBuyVipModalShow'
      :bag-info='modalBagInfo'
      @change-modal-status='changeModalStatus'
    ></buy-vip-modal>
  
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { handleException } from "@/request/helpers.js";

import ShowCard from './components/home-top-card.vue';
import RightsList from './components/home-rights-list.vue';
import UpgradingConditions from './components/home-upgrade-about.vue';
import EntranceList from './components/home-bottom-entrance.vue';
import GiftBagList from './components/home-gift-bag.vue';
import BuyBtn from './components/home-buy-btn.vue';
import BuyVipModal from './components/buy-vip-modal.vue';

const _all = new Map([
  ['1', ['normal', '普通']],
  ['2', ['silver', '白银']],
  ['3', ['gold', '黄金']],
  ['4', ['platinum', '白金']],
  ['5', ['diamond', '钻石']]
]);

export default {
  data () {
    return {
      currentIndex: '5',
      isBuyVipModalShow: false,
      modalLevel: -1
    }
  },
  components: {
    ShowCard,
    RightsList,
    UpgradingConditions,
    EntranceList,
    GiftBagList,
    BuyBtn,
    BuyVipModal,
  },
  computed: {
    ...mapGetters('vipCard/home', [
      'bottomList',
      'rightsList',
      'conditionList',
      'deadline',
      'isup',
      'privBuyList',
      'privLeft',
      'privList',
      'privUpV2List',
      'viplevel'
    ]),
    /**
     * 当前页会员等级礼包
     */
    bagInfo() {
      let _target = this.privUpV2List.find(item => item.vipLevel ==  this.currentIndex) || {};
      _target.itemList && _target.itemList.map(item => {
        if ( item.isBuy ) {
          item.btnText = item.type == 1 ? '查看礼包' : '礼包已到账';
        } else {
          item.btnText = '立即购买';
        }
      });
      return _target ;
    },
    /**
     * 弹窗会员等级礼包
     */
    modalBagInfo() {
      let _target = this.privUpV2List.find(item => item.vipLevel ==  this.modalLevel) || {};
      return _target.itemList;
    },
    /**
     * 会员等级名称
     */
    levelName() {
      return _all.get(this.currentIndex);
    },
    /**
     * 会员权益
     */
    showRightsList() {
      let _current = this.rightsList.find(item => item.vipLevel == this.currentIndex) || {};
      return _current && _current.itemList;
    },
    /**
     * 升级条件
     */
    showConditionList() {
      let _target = this.conditionList.find(item => item.vipLevel == this.currentIndex) || {};
      return _target && _target.itemList;
    },
    showModalInfo() {
      return this.privBuyList.find(item => item.vipLevel == this.modalLevel) || {}; 
    },
    /**
     * 底部购买按钮 
     * */
    buyBtnInfo() {
      return this.privList.find(item => item.vipLevel == this.currentIndex) || false;
    }
  },
  methods: {
    ...mapActions('vipCard/home', [
      'getVipDetail'
    ]),
    changeModalStatus( target ) {
      // console.log(target)
      if ( target.level && target.level == 3 ) {
        // console.log('去收银台')
        return false;
      }
      this.modalLevel = target.level ? target.level : this.currentIndex;
      this.isBuyVipModalShow = target.value;
    }
  },
  mounted () {
    // console.log('home mounted')
    this.getVipDetail()
      .catch(err => {
        handleException.call(this, err, true);
      });
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.vip-card-wrap {
  width: 100%;
  min-height: 100vh;
  background: #eeeff0;
  padding-bottom: 80 * $px;
}
</style>





// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/index.vue